export const SET_SURVEY = 'SURVEY/SET_SURVEY'
export const SET_SURVEYS = 'SURVEY/SET_SURVEYS'
